import { Component, ViewChild, ElementRef, Input } from "@angular/core";
import * as jspreadsheet from "jspreadsheet-ce";

@Component({
  selector: "app-spreadsheet",
  templateUrl: "./spreadsheet.component.html",
  styleUrls: ["./spreadsheet.component.scss"],
})
export class SpreadsheetComponent {
  @ViewChild("spreadsheet") spreadsheet!: ElementRef;
  title: any = "";
  @Input() metricData: any;
  data: any;

  public ngOnChanges(): void {
    this.data = this.metricData.data.map((metric: any) => {
      return Object.keys(metric).map((data) => {
        return metric[data];
      });
    });
  }

  ngAfterViewInit() {
    jspreadsheet(this.spreadsheet.nativeElement, {
      data: this.data,
      colHeaders: Object.keys(this.metricData.data[0]).map((data) => {
        const lower = data.toLowerCase();
        return data.charAt(0).toUpperCase() + lower.slice(1);
      }),
      minDimensions: [this.metricData.data.length, 10],
      defaultColWidth: 100,
    });
  }
}
